import React from 'react'
import Icon from './Icon'

const GoTriangleLeft = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g>
      <path d="m12.5 20l15 15v-30l-15 15z" />
    </g>
  </Icon>
)

export default GoTriangleLeft



// WEBPACK FOOTER //
// ./icons/TriangleLeft.js